import React from "react";
import image1 from "../../../Assets/Compliance Certifictes/image.png";
import image2 from "../../../Assets/Compliance Certifictes/image2.png";

const OrganicInfoContainer = () => {
  return (
    <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
      {/* left side */}
      <div className="w-full">
        {/* heading */}
        <div className="py-4 md:py-10">
          <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
            <h1 className="">
              <span className="border-b-4 border-[#249742]">Orga</span>nic
              certification
            </h1>
          </div>
        </div>

        {/* content */}
        <div>
          <p className="font-normal text-lg text-[#4D4D4D]">
            Organic certification is a certification process for producers of
            organic food and other organic agricultural products. In general,
            any business directly involved in food production can be certified,
            including seed suppliers, farmers, food processors, retailers and
            restaurants. A lesser known counterpart is certification for organic
            textiles (or Organic clothing) that includes certification of
            textile products made from organically grown fibres.
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            Certification is essentially aimed at regulating and facilitating
            the sale of organic products to consumers. Individual certification
            bodies have their own service marks, which can act as branding to
            consumers—a certifier may promote the high consumer recognition
            value of its logo as a marketing advantage to producers.
          </p>
        </div>
      </div>

      {/* right side */}
      <div className="grid sm:grid-cols-2 grid-cols-1 gap-4">
        <div className="py-0 sm:py-8">
          <img
            src={image2}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>

        <div className="py-0 sm:py-8">
          <img
            src={image1}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default OrganicInfoContainer;
